import api from '@app/api'

// TODO: удалить, когда пропадет надобность
import mockMonitoringsTypesWithSubtypes from '@app/api/mocks/monitoringTypesWithSubtypes.json'

import { CONTENT_TYPES } from '@app/api/constants'

import { EditedData } from '@app/pages/ClassifierControlsPage/hooks/useClassifierControlEditableColumn/types'

import type { AblePaginatedResponseFn, ResponseDto } from '@app/api/dtos'
import type {
  ClassifierControlCategoriesTypeDto,
  ClassifierControlsTypeDto,
  MonitoringsKindDto,
  MonitoringsSubtypesTypeDto,
  MonitoringsTypeDto,
  MonitoringsTypesWithSubtypesDto
} from './dtos'

import type {
  GetKindsParams,
  GetTypesParams,
  PatchTypesData,
  PatchMonitoringTypeData,
  ExportMonitoringsClassifierParams
} from './types'
import type { PaginatedParams, PaginationParams } from '@app/types/pagination'

const isMock = false

const URL = '/monitorings/'

const DEFAULT_PARAMS = {
  limit: 1500
}

export const getKinds: AblePaginatedResponseFn<GetKindsParams, MonitoringsKindDto> = async params => {
  const url = `${URL}kinds/`

  const response = await api.get(url, { params })
  return response.data
}

export const getTypes: AblePaginatedResponseFn<GetTypesParams, MonitoringsTypeDto> = async params => {
  const url = `${URL}types/`

  const response = await api.get(url, { params })
  return response.data
}

export const patchTypes = async ({ id, ...restData }: PatchTypesData): Promise<void> => {
  if (isMock) {
    // eslint-disable-next-line no-console
    console.log('patch types data', id, restData)
  } else {
    await api.patch(`${URL}types/${id}/`, restData)
  }
}

export const getSubtypesTypes: AblePaginatedResponseFn<GetTypesParams, MonitoringsSubtypesTypeDto> = async params => {
  const url = `${URL}subtypes/`

  const response = await api.get(url, { params })
  return response.data
}

// TODO: Проверить нейминг, url, мок данные, интерфейсы, как будет известен роут и схема ?? update
export const getMonitoringsTypesWithSubtypes = async (
  params: PaginatedParams<GetTypesParams> = DEFAULT_PARAMS
): Promise<ResponseDto<MonitoringsTypesWithSubtypesDto>> => {
  return await new Promise(resolve =>
    resolve(mockMonitoringsTypesWithSubtypes as unknown as ResponseDto<MonitoringsTypesWithSubtypesDto>)
  )

  // if (isMock) {
  //   return await new Promise(resolve => resolve(mockMonitoringsTypes as unknown as ResponseDto<MonitoringsTypesWithSubtypes>))
  // } else {
  //   const response = await api.get<ResponseDto<MonitoringsTypesWithSubtypes>>(`${URL}types/subtypes/`, { params })
  //   return response.data
  // }
}

// TODO: Проверить нейминг, url, мок данные, интерфейсы, как будет известен роут и схема
export const patchMonitoringsTypeWithSubtypes = async ({ id, ...data }: PatchMonitoringTypeData): Promise<void> => {
  // eslint-disable-next-line no-console
  console.log('patch monitoring type data: ', id, data)

  // if (isMock) {
  //   // eslint-disable-next-line no-console
  //   console.log('patch monitoring type data: ', id, data)
  // } else {
  //   const response = await api.patch(`${URL}types/subtypes/${id}`, data)
  //   return response.data
  // }
}

export const getMonitoringCategories = async (
  params?: PaginationParams
): Promise<ResponseDto<ClassifierControlCategoriesTypeDto>> => {
  const url = `${URL}categories/`

  const response = await api.get(url, { params })
  return response.data
}

export const getMonitoringCategoriesKinds = async (
  params?: PaginationParams
): Promise<ResponseDto<ClassifierControlsTypeDto>> => {
  const url = `${URL}categories-kinds/`

  const response = await api.get(url, { params })
  return response.data
}

export const putMonitoringCategoriesKinds = async (data: EditedData): Promise<void> => {
  const url = `${URL}categories-kinds/`

  await api.put<ResponseDto<EditedData>>(url, data)
}

export const exportMonitoringCategoriesKinds = async (
  params: ExportMonitoringsClassifierParams,
  signal?: AbortSignal
): Promise<Blob> => {
  const url = `${URL}categories-kinds/export/`

  const response = await api.get<Blob>(url, {
    signal,
    params,
    responseType: 'blob',
    headers: {
      'Content-Type': CONTENT_TYPES.applicationOfficedocumentSpreadsheetml
    }
  })

  return response.data
}
